import { createFileRoute } from "@tanstack/react-router";

import Transactions from "@/features/transactions/company/transaction-todos";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/transaktionen/todos",
)({
  component: TransactionsPage,
  staticData: {
    breadcrumb: ["bank.link"],
  },
});

function TransactionsPage() {
  return <Transactions />;
}
